import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function OrdinalsLegendary({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><g id="Group"><g id="Group_2"><path vectorEffect="non-scaling-stroke" id="Path" d="M11.8099 1.93994L3.18994 16.8599" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_2" d="M20.8099 16.8599L12.1899 1.93994" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_3" d="M20.6099 17.2H3.38989" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_4" fillRule="evenodd" clipRule="evenodd" d="M21 7.95896V16.042C21 16.757 20.619 17.417 20 17.774L13 21.815C12.381 22.172 11.619 22.172 11 21.815L4 17.774C3.381 17.417 3 16.756 3 16.042V7.95896C3 7.24396 3.381 6.58396 4 6.22696L11 2.18596C11.619 1.82896 12.381 1.82896 13 2.18596L20 6.22696C20.619 6.58396 21 7.24396 21 7.95896Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></g><path vectorEffect="non-scaling-stroke" id="Path_5" d="M20 17L12 12" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_6" d="M12 12V3" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /><path vectorEffect="non-scaling-stroke" id="Path_7" d="M12 12L4 17" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></g></Svg>;
}
export default OrdinalsLegendary;